<template>
    <div class="video-wrapper">
        <video class="demo-video" ref="player" muted autoplay></video>
    </div>
</template>
<script>
import flvjs from "flv.js";
export default {
    data() {
        return {
            id: "123",
            // rtsp: "rtsp://localhost:8554/rtsp/test_rtsp",

            rtsp: "rtsp://admin:kn123456@192.168.31.253:554/h264/",
            player: null
        }
    },
    mounted() {
        if (flvjs.isSupported()) {
            let video = this.$refs.player;
            if (video) {
                this.player = flvjs.createPlayer({
                    type: "flv",
                    isLive: true,
                    url: `ws://localhost:9999/rtsp/${this.id}/?url=${this.rtsp}`
                });
                this.player.attachMediaElement(video);
                try {
                    this.player.load();
                    this.player.play();
                } catch (error) {
                    console.log(error);
                }
            }
        }
    },
    beforeDestroy() {
        this.player.destory();
    }
}
</script>
<style>
.video-wrapper {
    max-width: 880px;
    max-height: 660px;
    border: 1px solid red;
}

.demo-video {
    max-width: 880px;
    max-height: 660px;
}
</style>


// WEBPACK FOOTER //
// src/views/other/video3.vue